import {integrityShift} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadIntegrityTurn(selection: any) {
  return useLoad(integrityShift, 'revision', {values: selection});
}

export default useLoadIntegrityTurn;
